<template>
  <div class="Index">
    <Swiper :dataList="kvList"></Swiper>
    <Sfq></Sfq>
    <section class="first-section">
      <img src="../assets/index/first-left.png" alt="" class="wow left" data-wow-duration="1s">
      <div class="center">
        <div class="wow title" data-wow-duration="1s">小森案例</div>
        <div class="wow descr" data-wow-duration="1s">
          <p>以三棵树小森板产品创造健康、多元、实用的经典</p>
          <p>落地项目，一站式整体服务及高效施工模式，为用</p>
          <p>户提供“无醛”生活空间和美好生活方式。</p>
        </div>
        <a :href="`${$Path}/#/case/index`" class="wow toomore" >
          <img src="../assets/index/toomore.png" alt="" >
        </a>
      </div>
      <img src="../assets/index/first-right.png" alt="" class="wow right" data-wow-duration="1s">
    </section>
    <section class="second-section">
      <div class="wow center">
        <div class="wow title" data-wow-duration="1s">解决方案</div>
        <div class="wow descr" data-wow-duration="1s">
          <p>提供建筑空间模块领域的完善解决</p>
          <p>方案，对三棵树小森板环保场景应</p>
          <p>用进行优化升级，从而提高空间装</p>
          <p>配系统产品的适配性能。</p>
        </div>
        <a :href="`${$Path}/#/solution/index`" class="wow toomore" >
          <img src="../assets/index/toomore.png" alt="" >
        </a>
      </div>
      <img src="../assets/index/man.png" alt="" class="man">
    </section>
    <section class="third-section">
      <!-- 小森服务 -->
      <img src="../assets/index/third-left.png" alt="" class="third-left">
      <div class="center">
        <div class="wow title">小森服务</div>
        <div class="wow descr">
          <p>集成设计圈、预约订制、评价有礼为一体</p>
          <p>的三棵树小森板快捷服务专区，聆听三棵</p>
          <p>树小森板业主真实心声，打造空间环保升</p>
          <p>级体验，赋予城市焕。</p>
        </div>
        <a :href="`${$Path}/#/serve/index`" class="wow toomore" >
          <img src="../assets/index/toomore.png" alt="" >
        </a>
      </div>
      <img src="../assets/index/third-right.png" alt="" class="wow third-right">
      <div class="wow third-one">
        <img src="../assets/index/third-one.png" alt="">
      </div>
      <div class="wow third-two">
        <img src="../assets/index/third-two.png" alt="">
      </div>
      <div class="wow third-three">
        <img src="../assets/index/third-three.png" alt="">
      </div>
      <!-- 四个板块 -->
      <div src="../assets/index/leaf.png" alt="" class="left-leaf"></div>
      <div src="../assets/index/leaf.png" alt="" class="right-leaf"></div>
      <div class="wow four-plate-box" data-wow-duration="1s">
        <a class="first-plate" :href="`${$Path}/#/goin/im`">
          <img src="../assets/index/first-plate.png">
          <div class="title">我是小森</div>
        </a>
        <a class="second-plate" :href="`${$Path}/#/goin/news`">
          <img src="../assets/index/second-plate.png">
          <div class="title">小森新闻</div>
        </a>
        <a class="third-plate" :href="`${$Path}/#/goin/honur`">
          <img src="../assets/index/third-plate.png">
          <div class="title">小森荣誉</div>
        </a>
        <a class="fourth-plate" :href="`${$Path}/#/joinus/recruit`">
          <img src="../assets/index/fourth-plate.png">
          <div class="title">加入我们</div>
        </a>
      </div>
      <div class="joinUS">
        <img class="wow" src="../assets/index/joinus.png" alt="" srcset="" data-wow-duration="1s">
        <a class="joinbtn" :href="`${$Path}/#/joinus/merchants`">招商加盟</a>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '../components/swiper.vue'
import Sfq from '../components/sfq.vue'
import WOW from '../../node_modules/wowjs/dist/wow';
import { doAdvertiseGeneralList } from "@/api/case.js";
export default {
  name: 'Index',
  components: {
    Swiper,
    Sfq,
  },
  data() {
    return {
      kvList: []
    }
  },
  created() {
    this.getImageList() 
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0,0)
    })
    let wow = new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 180,
      mobile: true,
      live: true
    });
    wow.init();
  },
  methods: {
    getImageList() {
      doAdvertiseGeneralList({
        adv_sign: 0,
        adv_type: '203',
        adv_state: '-1',
        keyword: '',
        pageNum: 1,
        pageSize: 10
      }).then((res) => {
        if (res.result == 1) {
          this.kvList = res.dataList
        } else {
          this.$message(res.msg)
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.Index {
  max-width: 1920px;
  overflow: hidden;
  margin: 0 auto;
  
  // first section
  .first-section {
    width: 100%;
    height: 1740px;
    background: url('../assets/index/first-bg.png')no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    margin: 0 auto;
    .left {
      width: 1001px;
      height: 700px;
      position: absolute;
      top: 82px;
      left: 100px;
      z-index: 2;
      animation: first-left 2s forwards;
    }
    .center {
      width: 920.5px;
      height: 363.6px;
      background: #C9B19F;
      position: absolute;
      top: 601px;
      left: 504px;
      z-index: 3;
      border-radius: 130px 0 130px 0;
      .title {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        top: 62px;
        left: 126px;
        animation: textFadeupin 1s forwards;
        opacity: 0;
      }
      .descr {
        width: 674px;
        font-size: 28px;
        line-height: 36px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        position: absolute;
        top: 132px;
        left: 126px;
        animation: textFadeupin 1s forwards;
        animation-delay: 0.5s;
        opacity: 0;
        p {
          margin: 0;
        }
      }
      .toomore {
        width: 141px;
        height: 29px;
        position: absolute;
        bottom: 65px;
        right: 94px;
        animation: textFadeupin 1s forwards;
        animation-delay: 1s;
        opacity: 0;
        img {
          width: 100%;
          vertical-align: top;
        }
      }
    }
    .right {
      width: 1001px;
      height: 701px;
      position: absolute;
      top: 798px;
      right: 108px;
      z-index: 2;
      animation: first-right 2s forwards;
    }
  }
  // second section
  .second-section {
    width: 100%;
    height: 781px;
    background: url('../assets/index/second-bg.png')no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    margin: 0 auto;
    .center {
      width: 977.5px;
      height: 406px;
      position: absolute;
      top: 254px;
      left: 350px;
      z-index: 1;
      border-radius: 130px 0 130px 0;
      .title {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        top: 58px;
        left: 119px;
        animation: textFadeupin 1s forwards;
        opacity: 0;
      }
      .descr {
        font-size: 28px;
        line-height: 36px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        position: absolute;
        top: 137px;
        left: 126px;
        animation: textFadeupin 1s forwards;
        animation-delay: 0.5s;
        opacity: 0;
        p {
          margin: 0;
        }
      }
      .toomore {
        width: 141px;
        height: 30px;
        position: absolute;
        bottom: 65px;
        left: 118px;
        animation: textFadeupin 1s forwards;
        animation-delay: 1s;
        opacity: 0;
        img {
          width: 100%;
          vertical-align: top;
        }
      }
    }
    .man {
      width: 964px;
      height: 1046px;
      position: absolute;
      top: -151px;
      left: 870px;
      z-index: 3;
      // transform: scale(0.9);
    }
  }
  // third-section
  .third-section {
    width: 100%;
    height: 3456px;
    background: url('../assets/index/third-bg.png')no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    margin: 0 auto;
    .third-left {
      width: 1087px;
      height: 608px;
      position: absolute;
      top: 52px;
      left: 196px;
      z-index: 2;
    }
    .center {
      width: 756px;
      height: 422px;
      background: #C9B19F;
      border-radius: 130px 0 130px 0;
      position: absolute;
      top: 612px;
      left: 135px;
      z-index: 1;
      .title {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        top: 75px;
        left: 81px;
        animation: textFadeupin 1s forwards;
        opacity: 0;
      }
      .descr {
        font-size: 28px;
        line-height: 36px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        position: absolute;
        top: 151px;
        left: 79px;
        animation: textFadeupin 1s forwards;
        animation-delay: 0.5s;
        opacity: 0;
        p {
          margin: 0;
        }
      }
      .toomore {
        width: 141px;
        height: 30px;
        position: absolute;
        bottom: 65px;
        left: 77px;
        animation: textFadeupin 1s forwards;
        animation-delay: 1s;
        opacity: 0;
        img {
          width: 100%;
          vertical-align: top;
        }
      }
    }
    .third-right {
      width: 1002px;
      height: 608px;
      position: absolute;
      top: 561px;
      right: 0;
      z-index: 1;
    }
    .third-one {
      width: 312px;
      height: 1132px;
      position: absolute;
      top: 0;
      left: 791px;
      z-index: 4;
      animation: third-right 1s forwards;
      opacity: 0;
      display: flex;
      align-items: flex-end;
      img {
        width: 100%;
      }
    }
    .third-two {
      width: 717px;
      height: 1179px;
      position: absolute;
      top: 0;
      left: 864px;
      z-index: 3;
      animation: third-right 1s forwards;
      animation-delay: 1s;
      opacity: 0;
      display: flex;
      align-items: flex-end;
      img {
        width: 100%;
      }
    }
    .third-three {
      width: 381px;
      height: 919px;
      position: absolute;
      top: 0;
      left: 1424px;
      z-index: 2;
      animation: third-right 1s forwards;
      animation-delay: 2s;
      opacity: 0;
      display: flex;
      align-items: flex-end;
      img {
        width: 100%;
      }
    }
    .left-leaf {
      width: 495px;
      height: 597px;
      position: absolute;
      top: 1323px;
      left: 0;
      z-index: 1;
      background: url('../assets/index/leaf.png')no-repeat right top;
    }
    .right-leaf {
      width: 482px;
      height: 597px;
      position: absolute;
      top: 1640px;
      right: 0;
      z-index: 1;
      background: url('../assets/index/leaf.png')no-repeat left top;
    }
    .four-plate-box {
      width: 1673px;
      height: 893px;
      position: absolute;
      top: 1332px;
      left: 50%;
      margin-left: -836.5px;
      z-index: 2;
      animation: textFadeupin 4s forwards;
      .first-plate {
        width: 402px;
        height: 718px;
        position: absolute;
        top: 167px;
        left: 0;
        border-radius: 117px 0 117px 0;
        border: 5px solid transparent;
        -webkit-user-select: none;
        cursor: pointer;
        &:hover {
          border-color: #66B22F;
          box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.5);
          transition: all 0.5s linear;
          transform: translateY(-2px);
        }
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
        .title {
          width: 100%;
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          bottom: 66px;
          left: 0;
        }
      }
      .second-plate {
        width: 408px;
        height: 724px;
        position: absolute;
        top: 0;
        left: 418px;
        border-radius: 117px 0 117px 0;
        border: 5px solid transparent;
        -webkit-user-select: none;
        cursor: pointer;
        &:hover {
          border-color: #66B22F;
          box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.5);
          transition: all 0.5s linear;
          transform: translateY(-2px);
        }
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          width: 100%;
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          bottom: 66px;
          left: 0;
        }
      }
      .third-plate {
        width: 408px;
        height: 724px;
        position: absolute;
        top: 169px;
        left: 838px;
        border-radius: 117px 0 117px 0;
        border: 5px solid transparent;
        -webkit-user-select: none;
        cursor: pointer;
        &:hover {
          border-color: #66B22F;
          box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.5);
          transition: all 0.5s linear;
          transform: translateY(-2px);
        }
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          width: 100%;
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          bottom: 66px;
          left: 0;
        }
      }
      .fourth-plate {
        width: 408px;
        height: 724px;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 117px 0 117px 0;
        border: 5px solid transparent;
        -webkit-user-select: none;
        cursor: pointer;
        &:hover {
          border-color: #66B22F;
          box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.5);
          transition: all 0.5s linear;
          transform: translateY(-2px);
        }
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          width: 100%;
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          bottom: 66px;
          left: 0;
        }
      }
    }
    .joinUS {
      width: 1738px;
      height: 914px;
      position: absolute;
      left: 50%;
      bottom: 146px;
      transform: translateX(-50%);
      z-index: 1;
      border-radius: 40px 0 40px 0;
      overflow: hidden;
      img {
        width: 1738px;
        height: 914px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        animation: imageScale 2s forwards;
      }
      .joinbtn {
        width: 196px;
        height: 67px;
        font-size: 36px;
        font-weight: 400;
        color: #FFFFFF;
        text-decoration: none;
        background: #4E8B46;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 420px;
        left: 783px;
        z-index: 3;
        border-radius: 30px 0 30px 0;
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
@keyframes first-left {
  0% {
    transform: translateX(-50px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes first-right {
  0% {
    transform: translateX(50px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes third-right {
  0% {
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>